import Papa from 'papaparse';

export type TenantInfo = {
    id: string
    name: string,
    logo?: string
};

class Util {
    
    public static async extractFileMetaData(file:any) {
        const promise = new Promise((resolve, reject) =>{
            Papa.parse(file, {
            worker: true,
            header: true,
            dynamicTyping: true,
            complete(results) {
                console.log(`done parsing => ${  file.name}`);
                resolve(results);
            },
            error(error) {
                console.log(`error parsing => ${  file.name}`);
                reject(error);
            },
            });
        });

        return promise;
    }

    public static getCurrentTenantInfo(): TenantInfo {
        return {
            id: localStorage.getItem("X-Tenant-Id"),
            name: localStorage.getItem("X-Tenant-Name"),
            logo: localStorage.getItem("X-Tenant-Logo"),
        };
    }

    public static getSessionCurrentTenantInfo(): TenantInfo {
      return {
          id: sessionStorage.getItem("X-Tenant-Id"),
          name: sessionStorage.getItem("X-Tenant-Name"),
          logo: sessionStorage.getItem("X-Tenant-Logo"),
      };
  }

    public static setCurrentTenantInfo(ti:TenantInfo) {
        localStorage.setItem("X-Tenant-Id", ti.id);
        localStorage.setItem("X-Tenant-Name", ti.name);
        localStorage.setItem("X-Tenant-Logo", ti.logo);
    }

    public static setSessionCurrentTenantInfo(ti:TenantInfo) {
      sessionStorage.setItem("X-Tenant-Id", ti.id);
      sessionStorage.setItem("X-Tenant-Name", ti.name);
      sessionStorage.setItem("X-Tenant-Logo", ti.logo);
  }

    public static resetCurrentTenantInfo() {
        localStorage.removeItem("X-Tenant-Id");
        localStorage.removeItem("X-Tenant-Name");
        localStorage.removeItem("X-Tenant-Logo");
    }

    public static popupWindow(url:string, windowName:string, use_window_location:boolean = true) {
        if(use_window_location){
          url = window.location.origin + url;
        }
        
        // TODO: adjust for all resolutions...
        const w = 600;
        const h = 500;
        const y = window.top!.outerHeight / 2 + window.top!.screenY - ( h / 2);
        const x = window.top!.outerWidth / 2 + window.top!.screenX - ( w / 2);
        return window.open(url, windowName, 
          `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, 
          resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`);
      }

    public static generateNewConfigName = () => {
        const currentDate = new Date()
        const currentYear = currentDate.getFullYear()
        const currentMonth = currentDate.getMonth()+1
        const currentDay = currentDate.getDate()
        const configDate = `${currentYear}/${currentMonth}/${currentDay}`

        const getRandomInt = (min, max) => {
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }

        const currentTenant = Util.getSessionCurrentTenantInfo() && Util.getSessionCurrentTenantInfo().id ? 
          Util.getSessionCurrentTenantInfo() : Util.getCurrentTenantInfo()

        return `${configDate}-${currentTenant.name}-Configuration-${getRandomInt(100,999)}`           
    }

    public static formatShortDate = (date: Date, hasNoDot: Boolean = false) => {
      const formattedDay = date.toLocaleString(undefined, {day:'2-digit'});
      const formattedMonth = date.toLocaleString(undefined, {month:'short'});
      const formattedYear = date.toLocaleString(undefined, {year:'numeric'});
    
      return (
        <span style={{fontStyle: hasNoDot ? 'normal' : 'italic', fontWeight: hasNoDot ? '700' : '400'}}>
          {formattedDay} {formattedMonth}{formattedMonth === 'May' || hasNoDot? '' : '.'} {formattedYear}
        </span>
      );
    };

    public static formatLongDate = (date: Date) => {
        const formattedDay = date.toLocaleString(undefined, {day:'numeric'});
        const formattedMonth = date.toLocaleString(undefined, {month:'short'});
        const formattedYear = date.toLocaleString(undefined, {year:'numeric'});
        const suffix = Util.getDaySuffix(date.getDate());
        const hasMonthDot = formattedMonth === 'May'
      
        return (
          <span>
            {formattedMonth}{hasMonthDot? '' : '.'}, {formattedDay}
            <sup
              style={{
                fontSize: "0.6em",
                verticalAlign: "super",
                lineHeight: "normal",
              }}
            >
              {suffix}
            </sup>{" "}
            {formattedYear}
          </span>
        );
      };
    
    public static getDaySuffix = (day) => {
        if (day >= 11 && day <= 13) {
          return 'th';
        }
      
        switch (day % 10) {
          case 1:
            return 'st';
          case 2:
            return 'nd';
          case 3:
            return 'rd';
          default:
            return 'th';
        }
      };
      
      
}

export default Util;